import { PropTypes } from 'prop-types';
import { WORLDMAP_METRIC } from '../../components/widgets/world/WorldMapConstants';

const alarm = PropTypes.exact({
   type: PropTypes.string,
   message: PropTypes.string,
});

const filter = PropTypes.exact({
   hash: PropTypes.string,
   name: PropTypes.string,
   countries: PropTypes.arrayOf(
      PropTypes.exact({
         value: PropTypes.string,
         label: PropTypes.string,
      }),
   ),
   tags: PropTypes.arrayOf(
      PropTypes.exact({
         value: PropTypes.string,
         label: PropTypes.string,
      }),
   ),
   events: PropTypes.arrayOf(
      PropTypes.exact({
         value: PropTypes.string,
         label: PropTypes.string,
      }),
   ),
   streamNames: PropTypes.arrayOf(
      PropTypes.exact({
         value: PropTypes.string,
         label: PropTypes.string,
      }),
   ),
});

const timespan = PropTypes.exact({
   id: PropTypes.number,
   visible: PropTypes.bool,
   type: PropTypes.string,
   label: PropTypes.string,
   span: PropTypes.string,
   interval: PropTypes.string,
   format: PropTypes.string,
   gte: PropTypes.object,
   lt: PropTypes.object,
   utcOffset: PropTypes.string,
   title: PropTypes.string,
   valid: PropTypes.bool,
});

const countries = PropTypes.arrayOf(
   PropTypes.exact({
      value: PropTypes.string,
      label: PropTypes.string,
   }),
);

const tags = PropTypes.arrayOf(
   PropTypes.exact({
      value: PropTypes.string,
      label: PropTypes.string,
   }),
);

const events = PropTypes.arrayOf(
   PropTypes.exact({
      value: PropTypes.string,
      label: PropTypes.string,
   }),
);

const settings = PropTypes.exact({
   weekType: PropTypes.string,
});

const userInfo = PropTypes.exact({
   token: PropTypes.any,
   expires: PropTypes.object,
   user: PropTypes.exact({
      email: PropTypes.string,
   }),
   organization: PropTypes.exact({
      name: PropTypes.string,
   }),
});

const currentView = PropTypes.string;

const cancelToken = PropTypes.exact({
   token: PropTypes.any,
   cancel: PropTypes.func,
});

const worldmapMetric = PropTypes.exact({
   value: PropTypes.string,
   label: PropTypes.string,
});

const worldmapSubSwitch = PropTypes.exact({
   [WORLDMAP_METRIC.PI]: PropTypes.string,
   [WORLDMAP_METRIC.ABR_PLAYTIME]: PropTypes.string,
});

const worldmapOptions = PropTypes.exact({
   cdn: PropTypes.object,
});

const troubleTimespan = PropTypes.exact({
   start: PropTypes.object,
   end: PropTypes.object,
   interval: PropTypes.object,
});

const troubleMode = PropTypes.string;

const troubleIngestInput = PropTypes.exact({
   ingestInput: PropTypes.string,
});

const troubleIngestStream = PropTypes.exact({
   ingestStream: PropTypes.string,
});

const troubleSelectedPublish = PropTypes.exact({
   publishStart: PropTypes.string,
   publishEnd: PropTypes.string,
   publishFineStart: PropTypes.string,
   publishFineEnd: PropTypes.string,
});

const troublePlayoutInput = PropTypes.exact({
   userId: PropTypes.string,
});

const troublePlayoutStream = PropTypes.string;

const troubleSelectedPlayout = PropTypes.exact({
   playerId: PropTypes.string,
   playoutFineStart: PropTypes.string,
   playoutFineEnd: PropTypes.string,
});

const stdSelectOption = PropTypes.exact({
   value: PropTypes.string,
   label: PropTypes.string,
});

const ipMisuseResultRow = PropTypes.exact({
   ip: PropTypes.string,
   orgaHash: PropTypes.string,
   durationSum: PropTypes.number,
   durationAvg: PropTypes.number,
   sessionCount: PropTypes.number,
   streamCount: PropTypes.number,
   tokenCount: PropTypes.number,
   topProviders: PropTypes.arrayOf(PropTypes.string),
   topCountries: PropTypes.arrayOf(PropTypes.string),
   topReferrers: PropTypes.arrayOf(PropTypes.string),
   topAgents: PropTypes.arrayOf(PropTypes.string),
   topTokens: PropTypes.arrayOf(PropTypes.string),
   streamStart: PropTypes.string,
   streamEnd: PropTypes.string,
   topTags: PropTypes.arrayOf(PropTypes.string),
   tagCount: PropTypes.number,
   concurrency: PropTypes.number,
   topStreams: PropTypes.arrayOf(
      PropTypes.exact({
         streamName: PropTypes.string,
         durationSum: PropTypes.number,
         durationAvg: PropTypes.number,
         sessionCount: PropTypes.number,
         tokenCount: PropTypes.number,
         streamStart: PropTypes.string,
         streamEnd: PropTypes.string,
         concurrency: PropTypes.number,
      }),
   ),
   blocked: PropTypes.any,
   action: PropTypes.string,
});

const jwtMisuseResultRow = PropTypes.exact({
   playbackToken: PropTypes.string,
   orgaHash: PropTypes.string,
   tokenPayload: PropTypes.exact({
      jti: PropTypes.string,
      sub: PropTypes.string,
      iat: PropTypes.string,
      exp: PropTypes.string,
      nbf: PropTypes.string,
      aud: PropTypes.arrayOf(PropTypes.string),
      tag: PropTypes.string,
      user: PropTypes.string,
      domain: PropTypes.string,
      ip: PropTypes.string,
      streams: PropTypes.arrayOf(PropTypes.string),
      cust: PropTypes.exact({
         raw: PropTypes.string,
         decoded: PropTypes.string,
      }),
      orgahash: PropTypes.string,
      forceDisconnect: PropTypes.bool,
      revocable: PropTypes.bool,
   }),
   durationSum: PropTypes.number,
   durationAvg: PropTypes.number,
   sessionCount: PropTypes.number,
   streamCount: PropTypes.number,
   ipCount: PropTypes.number,
   topIPs: PropTypes.arrayOf(PropTypes.string),
   topProviders: PropTypes.arrayOf(PropTypes.string),
   topCountries: PropTypes.arrayOf(PropTypes.string),
   topReferrers: PropTypes.arrayOf(PropTypes.string),
   topAgents: PropTypes.arrayOf(PropTypes.string),
   streamStart: PropTypes.string,
   streamEnd: PropTypes.string,
   topTags: PropTypes.arrayOf(PropTypes.string),
   tagCount: PropTypes.number,
   concurrency: PropTypes.number,
   topStreams: PropTypes.arrayOf(
      PropTypes.exact({
         streamName: PropTypes.string,
         durationSum: PropTypes.number,
         durationAvg: PropTypes.number,
         sessionCount: PropTypes.number,
         ipCount: PropTypes.number,
         streamStart: PropTypes.string,
         streamEnd: PropTypes.string,
         concurrency: PropTypes.number,
      }),
   ),
   blocked: PropTypes.any,
   action: PropTypes.string,
   revoked: PropTypes.bool,
});

const demoMode = PropTypes.exact({
   isActive: PropTypes.bool,
   demoUser: PropTypes.string,
});

const storePropTypes = {
   alarm,
   filter,
   timespan,
   countries,
   tags,
   events,
   settings,
   userInfo,
   currentView,
   cancelToken,
   worldmapMetric,
   worldmapSubSwitch,
   worldmapOptions,
   worldmapView: PropTypes.string,
   worldmapRegionZoom: PropTypes.string,
   troubleTimespan,
   troubleMode,
   troubleIngestInput,
   troubleIngestStream,
   troubleSelectedPublish,
   troublePlayoutInput,
   troublePlayoutStream,
   troubleSelectedPlayout,
   stdSelectOption,
   ipMisuseResultRow,
   jwtMisuseResultRow,
   demoMode,
};

export default storePropTypes;
